import { Component, Optional, ViewChild } from '@angular/core';
import { IonRouterOutlet, Platform } from '@ionic/angular';
import { Router } from '@angular/router';
import { App } from '@capacitor/app';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: false,
})
export class AppComponent {

  @ViewChild(IonRouterOutlet, { static: true }) routerOutlet!: IonRouterOutlet;

  constructor(
    private platform: Platform,
    private router: Router
  ) {
    this.initializeApp();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.handleBackButton();
    });
  }

  handleBackButton() {
    this.platform.backButton.subscribeWithPriority(10, () => {
      const url = this.router.url;

      // If we are at the root or login, we don't want to go back to login accidentally
      if (url === '/login' || url === '/menu/home' || url === '/home' || url === '/') {
        App.exitApp();
      } else {
        // Standard back navigation if possible
        if (this.routerOutlet.canGoBack()) {
          this.routerOutlet.pop();
        }
      }
    });
  }
}
